import { SearchItem } from '../../../entities';

export class InspectionSearchResultsCount {
  public TotalRecords: number;
  public CurrentPageInspectionIds: number[];
  public CurrentPageEqAndInspectionIds:EqAndInspectionIds[];
  unsyncInspectionData: [];
  
  temperatureInspectionData:[];
  repairEstimatesData:[];
}

export class EqAndInspectionIds{
  public EquipmentId:number;
  public InspectionId:number;
}
export class InspectionRowViewModel {
  constructor(
    public Dealer: string,
    public Examiner: string,
    public CustomerName: string,
    public Evaluation: string,
    public Eval_:string,
    public Family: string,
    public InspectionDate: Date,
    public JobsiteName: string,
    public Make: string,
    public Model: string,
    public SerialNumber: string,
    public UnitNumber: string,
    public Status: string,
    public EquipmentID:number,
    public AdditUnitNumber: string,
    public IsChain:boolean,
    public IsFlagged:boolean,
    public InspectionId:number,
    public IsFrame:number,
    public Eval: string
    ) { }
}

export interface InspectionData {
  TotalRecords: number;
  inspectionData: InspectionRowViewModel[];
}

export class InspectionSearchRequest {
  constructor(
    public PageNumber: number,
    public InspectionsPerPage: number,
    public SearchItems: SearchItem[],
    public OrderBy: OrderInspectionBy,
    public OnlyShowAwaitingInterp: boolean = false,

  ) {}
}


export class OrderInspectionBy {
  constructor( sortOption: SortOptions, selected: boolean = false){
    this.selected = selected;
    this.sortOption = sortOption;
  }
  public sortOption: SortOptions;
  public selected: boolean;
}

export enum SortOptions {
  Eval,
  InspectionDate,
  SerialNumber,
  UnitNumber,
  Customer,
  Jobsite,
  Make,
  Model,
  Family,
  Status,
  AwaitingInterpretation,
  Examiner,
  AddiUnitNumber,
}


export enum ViewedInspectionTypes {
 GeneralInspection,
 UnsyncInspection,
 RepairEstimates,
}
